<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div class="min-h-screen bg-white">
    <!-- 导航栏 -->
    <div class="sticky top-0 z-30 bg-white mx-auto px-4 py-4 flex items-center border-b shadow-sm">
      <div class="flex items-center">
        <button @click="goBack" class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors duration-200">
          <i class="fas fa-arrow-left text-lg"></i>
        </button>
        <span class="hidden md:block ml-2 text-gray-700">返回商品列表</span>
      </div>
      <h1 class="text-lg md:text-xl font-medium text-center flex-1">商品详情</h1>
      <div class="w-10 md:w-32"></div> <!-- 占位，保持标题居中 -->
    </div>

    <div class="min-h-screen bg-white">
      <!-- 主要产品展示区域 -->
      <div class="md:flex md:h-screen">
        <!-- 左侧产品图片展示 -->
        <div class="w-full md:w-1/2 relative bg-gray-50 overflow-hidden" ref="leftSection">
          <div
            class="sticky top-0 md:h-screen flex items-center justify-center p-8"
          >
            <div class="w-full max-w-lg">
              <Swiper
                :modules="swiperModules"
                :pagination="{ clickable: true }"
                :autoplay="{ delay: 3000 }"
                class="product-swiper"
              >
                <SwiperSlide
                  v-for="(image, index) in productImages"
                  :key="index"
                >
                  <div
                    class="aspect-square overflow-hidden rounded-lg shadow-lg cursor-pointer"
                    @click="openImageModal(image)"
                  >
                    <img
                      :src="image"
                      :alt="`产品图片 ${index + 1}`"
                      class="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>

        <!-- 右侧产品信息 -->
        <div class="w-full md:w-1/2 overflow-y-auto" ref="rightSection">
          <div class="p-12 space-y-12">
            <!-- 基础信息模块 -->
            <div class="space-y-6">
              <h1 class="text-4xl font-bold text-gray-900">
                {{ productInfo.name }}
              </h1>
              <div class="flex items-baseline space-x-4">
                <!-- 当有折扣时，显示带删除线的原价 -->
                <span v-if="productInfo.discountPrice && productInfo.discountPrice > 0"
                  class="text-xl line-through"
                >¥{{ productInfo.price ? productInfo.price.toLocaleString() : '0' }}</span>
                <!-- 始终显示实际支付价格 -->
                <span class="text-3xl font-bold text-red-600">
                  ¥{{ (productInfo.discountPrice > 0 && productInfo.discountPrice ? productInfo.discountPrice.toLocaleString() : productInfo.price ? productInfo.price.toLocaleString() : '0') }}
                </span>
              </div>
            </div>

            <!-- 品牌故事模块 -->
            <div class="space-y-4">
              <h2 class="text-2xl font-semibold text-gray-900">品牌故事</h2>
              <div class="text-gray-700 leading-relaxed space-y-4">
                <p v-if="productInfo.brandStory && productInfo.brandStory.paragraph1">{{ productInfo.brandStory.paragraph1 }}</p>
                <p v-if="productInfo.brandStory && productInfo.brandStory.paragraph2">{{ productInfo.brandStory.paragraph2 }}</p>
                <p v-if="productInfo.brandStory && productInfo.brandStory.paragraph3">{{ productInfo.brandStory.paragraph3 }}</p>
              </div>
            </div>

            <!-- 属性选择模块 -->
            <div class="space-y-8">
              <!-- 颜色选择 -->
              <div class="space-y-4">
                <h3 class="text-xl font-semibold text-gray-900">颜色选择</h3>
                <div class="flex flex-wrap gap-3">
                  <button
                    v-for="color in (productInfo.colors || [])"
                    :key="color.name"
                    @click="selectedColor = color.name"
                    :class="{
                      'ring-2 ring-blue-500': selectedColor === color.name,
                      'ring-1 ring-gray-300': selectedColor !== color.name,
                    }"
                    class="w-12 h-12 rounded-full cursor-pointer !rounded-button whitespace-nowrap transition-all duration-200 hover:scale-110"
                    :style="color.gradient && color.gradient.length >= 2 ? { background: `linear-gradient(135deg, ${color.gradient[0]}, ${color.gradient[1]})` } : { backgroundColor: color.value }"
                    :title="color.name"
                  ></button>
                </div>
                <p class="text-sm text-gray-600">已选择：{{ selectedColor }}</p>
              </div>

              <!-- 尺码选择 -->
              <div class="space-y-4" v-if="productInfo.sizes && productInfo.sizes.length > 0">
                <h3 class="text-xl font-semibold text-gray-900">尺码选择</h3>
                <div class="flex flex-wrap gap-3">
                  <button
                    v-for="size in productInfo.sizes"
                    :key="size"
                    @click="selectedSize = size"
                    :class="{
                      'bg-blue-600 text-white border-blue-600':
                        selectedSize === size,
                      'bg-white text-gray-700 border-gray-300 hover:border-gray-400':
                        selectedSize !== size,
                    }"
                    class="px-4 py-2 border-2 !rounded-button cursor-pointer whitespace-nowrap transition-all duration-200"
                  >
                    {{ size }}
                  </button>
                </div>
                <p class="text-sm text-gray-600">已选择：{{ selectedSize }}</p>
              </div>

              <!-- 购买按钮 -->
              <!-- <div class="flex space-x-4 pt-6">
              <button
                class="flex-1 bg-blue-600 text-white py-4 px-8 !rounded-button cursor-pointer whitespace-nowrap hover:bg-blue-700 transition-colors duration-200 font-semibold text-lg"
              >
                立即购买
              </button>
              <button
                class="flex-1 bg-gray-100 text-gray-900 py-4 px-8 !rounded-button cursor-pointer whitespace-nowrap hover:bg-gray-200 transition-colors duration-200 font-semibold text-lg"
              >
                加入购物车
              </button>
            </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 产品特点展示 -->
      <div class="py-20 px-12 bg-gray-50">
        <div class="max-w-6xl mx-auto">
          <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">
            产品特点
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div
              v-for="feature in productFeatures"
              :key="feature.title"
              class="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div class="text-center space-y-4">
                <!-- <div
                  class="w-16 h-16 mx-auto bg-blue-100 rounded-full flex items-center justify-center"
                >
                  <i :class="feature.icon" class="text-2xl text-blue-600"></i>
                </div> -->
                <h3 class="text-xl font-semibold text-gray-900">
                  {{ feature.title }}
                </h3>
                <p class="text-gray-600 leading-relaxed">
                  {{ feature.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品信息抽屉 -->
      <div class="py-20 px-12">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">
            产品详细信息
          </h2>
          <div class="space-y-4">
            <div
              v-for="(section, index) in productDetails"
              :key="index"
              class="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                @click="toggleSection(index)"
                :class="{
                  'bg-gray-50': expandedSections.includes(index),
                  'bg-white hover:bg-gray-50':
                    !expandedSections.includes(index),
                }"
                class="w-full px-6 py-4 text-left flex items-center justify-between cursor-pointer whitespace-nowrap transition-colors duration-200"
              >
                <span class="text-lg font-semibold text-gray-900">{{
                  section.title
                }}</span>
                <i
                  :class="{
                    'fa-chevron-up': expandedSections.includes(index),
                    'fa-chevron-down': !expandedSections.includes(index),
                  }"
                  class="fas transition-transform duration-200"
                ></i>
              </button>
              <div
                v-show="expandedSections.includes(index)"
                class="px-6 py-4 bg-white border-t border-gray-200"
              >
                <div class="grid md:grid-cols-2 gap-4">
                  <div
                    v-for="item in section.items"
                    :key="item.label"
                    class="flex justify-between py-2 border-b border-gray-100 last:border-b-0"
                  >
                    <span class="text-gray-600 font-medium">{{
                      item.label
                    }}</span>
                    <span class="text-gray-900">{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 图片放大模态框 -->
      <div
        v-if="showImageModal"
        @click="closeImageModal"
        class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-pointer"
      >
        <div class="max-w-4xl max-h-4xl p-4">
          <img
            :src="selectedImage"
            alt="产品大图"
            class="w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
SwiperCore.use([Pagination, Autoplay]);
// 引入样式
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper
const swiperModules = [Pagination, Autoplay];

//路由
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const goBack = () => {
  router.go(-1); // 或者使用 router.back();
};

// 响应式数据
const selectedColor = ref("经典黑");
const selectedSize = ref("M");
const expandedSections = ref<number[]>([]);
const showImageModal = ref(false);
const selectedImage = ref("");
const leftSection = ref<HTMLElement>();
const rightSection = ref<HTMLElement>();

// 导入产品数据API
import { getProductDetailWithPrice } from '../api/product.js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';

// 根据productId获取产品数据
const route = useRoute();
const productId = ref(route.params.id || '1'); // 从动态路由参数中获取ID，默认使用ID为1的产品
const productType = ref(route.query.type || 'bikeormore'); // 从查询参数中获取type，默认使用bikeormore

// 加载状态管理
const loading = ref(false);
const error = ref(null);

// 响应式数据 - 根据产品ID动态获取
const currentProduct = ref(null);
const productImages = ref([]);
// 初始化productInfo时设置默认值，避免undefined错误
//const productInfo = ref({ name: '加载中...', price: 0, discountPrice: 0, brandStory: {} });
const productInfo = ref([]);
const productFeatures = ref([]);
const productDetails = ref([]);

// 获取产品详情的函数
const fetchProductDetail = async (productId, typeParam) => {
  loading.value = true;
  error.value = null;
  try {
    // 调用API获取产品详情，传入产品ID和类型参数
    // getProductDetailWithPrice确保详情页显示与列表页一致的价格信息
    // console.log(productId, typeParam);
    const data = await getProductDetailWithPrice(productId, typeParam);
    currentProduct.value = data;
    productImages.value = data.images;
    productInfo.value = data.info;
    productFeatures.value = data.features;
    productDetails.value = data.details;
    
    // 重置选择状态
    if (productInfo.value && productInfo.value.colors && productInfo.value.colors.length > 0) {
      selectedColor.value = productInfo.value.colors[0].name;
    }
    if (productInfo.value && productInfo.value.sizes && productInfo.value.sizes.length > 0) {
      selectedSize.value = productInfo.value.sizes[0];
    }
  } catch (err) {
    error.value = '获取产品详情失败';
    console.error('获取产品详情错误:', err);
  } finally {
    loading.value = false;
  }
};

// 初始加载产品数据
fetchProductDetail(productId.value, productType.value);

// 监听路由参数变化，更新产品数据
// 修改为分别监听params和query，使用immediate确保组件挂载时也执行
watch(
  () => route.params.id,
  (newId) => {
    console.log('ID参数变化:', newId);
    if (newId) {
      productId.value = newId as string;
      fetchProductDetail(productId.value, productType.value);
    }
  },
  { immediate: true }
);

watch(
  () => route.query.type,
  (newType) => {
    console.log('Type参数变化:', newType);
    productType.value = newType as string || 'bikeormore';
    fetchProductDetail(productId.value, productType.value);
  },
  { immediate: true }
);

// 方法
const toggleSection = (index: number) => {
  const currentIndex = expandedSections.value.indexOf(index);
  if (currentIndex > -1) {
    expandedSections.value.splice(currentIndex, 1);
  } else {
    expandedSections.value.push(index);
  }
};

const openImageModal = (image: string) => {
  selectedImage.value = image;
  showImageModal.value = true;
};

const closeImageModal = () => {
  showImageModal.value = false;
  selectedImage.value = "";
};

onMounted(() => {
  // 同步滚动效果
  if (rightSection.value) {
    rightSection.value.addEventListener("scroll", () => {
      // 这里可以添加左右联动滚动逻辑
    });
  }
});
</script>

<style scoped>
.product-swiper {
  width: 100%;
  height: 100%;
}

.product-swiper .swiper-pagination-bullet {
  background: #3b82f6;
  opacity: 0.5;
}

.product-swiper .swiper-pagination-bullet-active {
  opacity: 1;
}

/* 隐藏数字输入框的箭头 */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* 自定义滚动条 */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
